import React from 'react'
import './SliderWrapper.scss'

const SliderWrapper = ({ children }) => (
  <div className="g-slider-wrapper">
    {children}
  </div>
);

export default SliderWrapper;
